import baseEnum from './base-enum'
export let requestTypes = Object.assign(
  {},
  {
    Callback: 'callback',
    Rezerv: 'rezerv',
    Ipoteka: 'ipoteka',
    Question: 'question',
    Excursion: 'excursion',
    Complaint: 'complaint',
    Compliment: 'compliment',
    Feedback: 'feedback',
    Corppartner: 'corppartner',
    Secondary: 'secondary',
    Press: 'press'
  },
  {
    name(alias) {
      switch (alias) {
        case this.Callback:
          return 'Заказать звонок'
        case this.Rezerv:
          return 'Резерв квартиры'
        case this.Ipoteka:
          return 'Заявка на ипотеку'
        case this.Question:
          return 'Задать вопрос'
        case this.Excursion:
          return 'Записаться на экскурсию'
        case this.Complaint:
          return 'Жалоба'
        case this.Compliment:
          return 'Похвалить'
        case this.Feedback:
          return 'Прочий фидбэк'
        case this.Corppartner:
          return 'Корпоративным клиентам'
        case this.Secondary:
          return 'Вторичная недвижимость'
        case this.Press:
          return 'Для прессы'
      }
      return alias
    }
  },
  baseEnum
)
